import { render, staticRenderFns } from "./reset-password-form.vue?vue&type=template&id=50fcb4c6"
import script from "./reset-password-form.vue?vue&type=script&lang=js"
export * from "./reset-password-form.vue?vue&type=script&lang=js"
import style0 from "./reset-password-form.vue?vue&type=style&index=0&id=50fcb4c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports